<template>
  <div id="app">
    <LayoutNav></LayoutNav>
    <router-view />
  </div>
</template>
<script>

import LayoutNav from './components/shop/LayoutNav'
export default {
  components: {
    LayoutNav,
  },
}
</script>
<style lang="scss" scoped>
* {
  color: #333;
  font-size: 15px;
  background: #f2f3f5;
}
</style>
